module.exports = __webpack_public_path__ + "img/symbol.ec75ad5d.svg";